import React from 'react';
import ClassNames from 'classnames';
import DateTime from 'utils/date-time';
import moment from 'moment-timezone';
import DayButton from 'components/date-picker/DayButton';

export default React.createClass({

	propTypes: {
		displayDate: React.PropTypes.object.isRequired,
		onDayTouchTap: React.PropTypes.func,
		selectedDate: React.PropTypes.object.isRequired,
		maxDate: React.PropTypes.object,
		minDate: React.PropTypes.object,
	},

	render() {
		let classes = ClassNames('lui-date-picker-calendar-month lui-transition-slide-in-child');

		return (
			<div className={classes}>
				{this._getWeekElements()}
			</div>
		);
	},

	_getWeekElements() {
		let weekArray = DateTime.getWeekArray(moment(this.props.displayDate));
		return weekArray.map(function(week, i) {
			return (
				<div
					key={i}
					className="lui-date-picker-calendar-month-week">
					{this._getDayElements(week)}
				</div>
			);
		}, this);
	},
	
	_isDisabled(day) {
		let minDate = this.props.minDate;
		let maxDate = this.props.maxDate;

		if(minDate != null && day < minDate){
		  return true;
		};

		if(maxDate != null && day > maxDate){
			return true;
		};

		return false;
	},

	_getDayElements(week) {
		return week.map(function(day, i) {
			let selected = moment(this.props.selectedDate).format("MMM DD YYYY") === moment(day).format("MMM DD YYYY"),
				disabled = this._isDisabled(day);
				
			return (
				<DayButton
					key={i}
					disabled={disabled}
					date={day}
					onTouchTap={this._handleDayTouchTap}
					selected={selected} />
			);
		}, this);
	},

	_handleDayTouchTap(e, date) {
		if (this.props.onDayTouchTap) this.props.onDayTouchTap(e, date);
	}

});


/** WEBPACK FOOTER **
 ** ./src/components/date-picker/CalendarMonth.js
 **/